module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8vn8Pj////z+PtsptLO4fCdxOG20umFtdpgns6RvN1Hj8fC2uypy+Xa6fSZV+70AAAAB3RSTlMAYL8AIM/vi50ITwAAANFJREFUeF7t2EluhEAMhtEa+Wtm6E7uf9SABFE25ULCWbW/AzwvkLDK6kgbPMhou6esdR4P8+6A3ITHTW6HPBjyVmmwpJUBS0aBKYEEYkgggUJMvfK7YG/JqVecwy/UEtUCoCaivN6DUhhAqV7QmkloA7ZE9qK/2jWiods5ogwhzCMIN6EmkEACCSTQP/9qX3EElb/QXDvFcx2ttVe+Nh/UgdKF0QaNuAV9YQSVE8I3Na0BKJlgapEnxEdDAgnEd2TRYElzHaLYTmOcx7o9jvPhDxKnl0w75mbKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f201.png
// module id = 622
// module chunks = 0